'use client';
import { Typography } from '@curology/ui-components-web/react';
import Image from 'next/image';
import React from 'react';

import { PriceSummaryItem } from './priceSummaryItem';
import { type ExpressCurologySignUpSkinPdpSourceConfigType } from '../types';
import {
  allArrayValuesInOtherArray,
  getFormattedPrice,
  getTotal,
} from '../utils';

export const PriceSummary = ({
  bundleConfig,
  giftWithPurchaseImageUrl,
  selectedAddOnProductItemIds,
}: {
  bundleConfig: ExpressCurologySignUpSkinPdpSourceConfigType;
  giftWithPurchaseImageUrl?: string;
  selectedAddOnProductItemIds: number[];
}) => {
  const {
    addOnProducts,
    dermatologyConsultationPrice,
    setProducts,
    shippingPrice,
  } = bundleConfig;

  const total = getTotal(bundleConfig, selectedAddOnProductItemIds);

  return (
    <div className="cur-bg-surface-neutral cur-p-4">
      <ul className="cur-m-0">
        {setProducts.map((setProduct, index) => {
          return setProduct.priceSummaryItems.map((priceSummaryItem) => {
            return (
              <PriceSummaryItem
                isFirstItem={index === 0}
                key={`${setProduct.id}_${priceSummaryItem.name}`}
                priceSummaryItem={priceSummaryItem}
              />
            );
          });
        })}
        {addOnProducts &&
          addOnProducts.map((addOnProduct) => {
            if (
              !allArrayValuesInOtherArray(
                addOnProduct.itemIds,
                selectedAddOnProductItemIds,
              )
            ) {
              return null;
            }

            return addOnProduct.priceSummaryItems.map((priceSummaryItem) => {
              return (
                <PriceSummaryItem
                  key={`${addOnProduct.id}_${priceSummaryItem.name}`}
                  priceSummaryItem={priceSummaryItem}
                />
              );
            });
          })}
        {giftWithPurchaseImageUrl && (
          <li className="cur-mt-4">
            <Image
              alt="Gift with Purchase banner"
              height={354}
              quality={100}
              src={giftWithPurchaseImageUrl}
              width={1080}
            />
          </li>
        )}
        <li className="cur-border-disabled cur-border-solid cur-border-t cur-flex cur-items-center cur-justify-between cur-mt-4 cur-pt-4">
          <Typography>Shipping</Typography>
          <Typography className="cur-uppercase">
            {getFormattedPrice(shippingPrice)}
          </Typography>
        </li>
        <li className="cur-flex cur-items-center cur-justify-between">
          <Typography>Dermatology consultation</Typography>
          <Typography className="cur-uppercase" weight="bold">
            {getFormattedPrice(dermatologyConsultationPrice, 'Included')}
          </Typography>
        </li>
        <li className="cur-bg-surface-highlight cur-flex cur-items-center cur-justify-between cur-mt-4 cur-p-4 cur-uppercase">
          <Typography>Total</Typography>
          <Typography weight="bold">{getFormattedPrice(total)}</Typography>
        </li>
      </ul>
    </div>
  );
};
